<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Fizz Club</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Fermentation, cooking, gatherings</p>
        <p>
Fizz Club is a casual gathering of people interested in fermentation in all its forms, coming together to cook, taste, discuss and enjoy. Some things that have come out of Fizz Club so far are fermented hot sauces and kimchi made in Varia, wild fermented mead and various cooking sessions during the <a href="https://www.bakonline.org/program-item/sancochotopia-a-winter-ultrahospitality-mini-garage-school/">Ultradependent Public School</a> at BAK Utrecht, and the basis of <a href="https://portfolio.alicestrete.me/relearn">Relearn 2021</a>.
</p>

<p>
Fizz club started as a continuation of the <a href="https://laagencia.net/wp-content/uploads/2020/09/SUMMER-FERMENT-ZINE-WEB.pdf">Garage School of Fermentation </a> that took place in the summer of 2020 in RIB . We want to keep on experimenting with fermentation in all shapes and forms to make tasty foods and drinks and share them and the process with others. In order to deepen the exploration of our intimate relation with the microcosmos of bacteria, we're delving into the transformative biopolitical relations that emerge from fermentation processes and metaphors. Fermentation rituals invite us to explore our entanglements to the microcosmos of life, history and food, as well as to the macrocosmos of time, space, and flow.
</p>
        <p>The project was initiated in collaboration with Santiago Piñol and Luke Murphy. The logo was designed by <a href="https://carlosaalfonso.com/">Carlos Alfonso</a></p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/fizz/fizz.png"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/fizz/chili.jpg"></b-img>


      </b-col>
      <b-col md="4">
        <b-img class="img-fluid" src="media/fizz/hotsauce.jpg"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/fizz/mead.jpg"></b-img>



      </b-col>


    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'ATNOFSPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
